import Lottie from 'react-lottie';
import animationData from '../../assets/animations/Clouds.json';

function TestField() {
  return (
    <div>
      <Lottie
        options={{
          animationData,
        }}
        isClickToPauseDisabled
      />
    </div>
  );
}

export default TestField;
